





























import { Component, Vue, Prop } from 'vue-property-decorator';
import BlockBox from './BlockBox.vue';
import { AppModule } from '@/store/modules/app';
import Message from '@/util/MessageWorker';

@Component({
  components: {
    BlockBox
  }
})
export default class Dashboard extends Vue {
  private activeName = '0';
  private searchText = '';

  private list = [];

  async created() {
    const blockList = await Message.emit('material.index.getBlocks');
    this.list = blockList.list;
  }

  private handleTab(data) {}

  private handleClose() {
    AppModule.SetShowDashboard(false);
  }
}
